import { render, staticRenderFns } from "./ClassifiedsErrorState.vue?vue&type=template&id=68f41467&"
import script from "./ClassifiedsErrorState.vue?vue&type=script&lang=ts&"
export * from "./ClassifiedsErrorState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports